export default {
      id: "plus-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#plus",
      toString: function () {
        return this.url;
      }
    }